import React, { memo, useCallback, useState, useMemo } from 'react';
import { createUseStyles, Password, Button, Advice } from '@Sage/hoi-poi-ui';

import useLoginLiterals from 'lib/useLoginLiterals';

import { FadeTransition } from 'components/Transitions';

import AuthBox from '../components/AuthBox';

import styles from './styles.js';
import PasswordPolicies from '../components/PasswordPolicies';
const useStyles = createUseStyles(styles, 'ChangePassword');

const ChangePassword = ({ logo, onSend, goLogin, iframeURL, policies }) => {
    const classes = useStyles();

    const [password, setPassword] = useState();
    const [password2, setPassword2] = useState();
    const [passwordError, setPasswordError] = useState();
    const [formState, setFormState] = useState({
        error: null,
        success: null,
        loading: false,
    });

    const { loading, t } = useLoginLiterals();

    const send = useCallback(
        (e) => {
            e?.preventDefault?.();

            if (!password || password !== password2) return;

            setFormState({
                error: null,
                success: null,
                loading: true,
            });

            onSend(password)
                .then((successLiteral) => {
                    setFormState({
                        success: t(successLiteral),
                        error: false,
                        loading: false,
                    });
                    setPassword('');
                    setPassword2('');
                })
                .catch((e) => {
                    console.error(e);
                    setFormState({
                        success: false,
                        error: t('error_generalerror'),
                        loading: false,
                    });
                });
        },
        [onSend, password, password2, t],
    );

    const checkPasswords = useCallback(() => {
        setPasswordError(password !== password2 ? t('error_password_validation') : '');
    }, [password, password2, t]);

    const allValid = useMemo(() => {
        return policies.every((policy) => policy.condition(password)) && password === password2;
    }, [password, password2, policies]);

    if (loading) return null;

    return (
        <AuthBox
            title={t('label_insert_new_password')}
            logo={logo}
            iframeURL={iframeURL ? t(iframeURL) : null}
        >
            {!formState.success && (
                <>
                    <FadeTransition transitionKey="error" show={formState.error}>
                        <Advice
                            className={classes.advice}
                            type="error"
                            showIcon
                            defaultCollapsed={false}
                            showCollapse={false}
                        >
                            {formState.error}
                        </Advice>
                    </FadeTransition>
                    <form autoComplete="off" onSubmit={send}>
                        <Password
                            label={t('label_new_password')}
                            placeholder={t('label_password')}
                            onChange={setPassword}
                            value={password}
                            isFullWidth
                            isDisabled={formState.loading}
                            autoFocus
                        />
                        <PasswordPolicies password={password} policies={policies} t={t} />
                        <Password
                            label={t('label_insert_repeat_new_password')}
                            placeholder={t('label_password')}
                            onChange={setPassword2}
                            onBlur={checkPasswords}
                            value={password2}
                            isFullWidth
                            isDisabled={formState.loading}
                            error={passwordError}
                        />
                        <div className={classes.footer}>
                            <Button
                                onClick={send}
                                isLoading={formState.loading}
                                isDisabled={!allValid}
                            >
                                {t('action_next')}
                            </Button>
                        </div>
                    </form>
                </>
            )}
            <FadeTransition transitionKey="sucess" show={formState.success}>
                <Advice
                    className={classes.advice}
                    type="success"
                    showIcon
                    defaultCollapsed={false}
                    showCollapse={false}
                >
                    {formState.success}
                </Advice>
                <div className={classes.footer}>
                    <Button onClick={goLogin}>{t('action_go_to_forcemanager')}</Button>
                </div>
            </FadeTransition>
        </AuthBox>
    );
};

export default memo(ChangePassword);
